import {Record} from 'immutable';
import {handleActions} from 'redux-actions';

import RoleAssignee from 'web-app/react/entities/common/role-assignee';

import * as Actions from './actions';

const ChangeRoleModalData = new Record({
    isSubmitting: false,
    isVisible: false,
    overrideTargetType: String(),
    assignee: RoleAssignee.default,
    institutionId: undefined,
    overrideSubmit: undefined,
    hideRemoveLogin: false,
    usePincodeCheckin: false,
});

const updateVisible = (state, isVisible) => state.merge({isVisible});
const updateSubmitting = (state, isSubmitting) => state.merge({isSubmitting});
const updateRequestSuccess = state => state.merge({isVisible: false, isSubmitting: false});

const changeRelationRoleModal = handleActions(
    {
        [Actions.show.type]: (state, action) => {
            return state.merge({
                isVisible: true,
                assignee: action.payload.assignee,
                overrideTargetType: action.payload.overrideTargetType,
                overrideSubmit: action.payload.overrideSubmit,
                hideRemoveLogin: action.payload.hideRemoveLogin,
                usePincodeCheckin: action.payload.usePincodeCheckin,
            });
        },
        [Actions.close.type]: state => updateVisible(state, false),

        [Actions.removeLogin.type]: state => updateSubmitting(state, true),
        [Actions.removeLoginFailed.type]: state => updateSubmitting(state, false),
        [Actions.removeLoginAborted.type]: state => updateSubmitting(state, false),
        [Actions.removeLoginSuccess.type]: state => updateRequestSuccess(state),

        [Actions.assignRole.type]: state => updateSubmitting(state, true),
        [Actions.assignRoleFailed.type]: state => updateSubmitting(state, false),
        [Actions.assignRoleSuccess.type]: state => updateRequestSuccess(state),

        [Actions.changeRole.type]: state => updateSubmitting(state, true),
        [Actions.changeRoleFailed.type]: state => updateSubmitting(state, false),
        [Actions.changeRoleSuccess.type]: state => updateRequestSuccess(state),
    },
    new ChangeRoleModalData(),
);

export default changeRelationRoleModal;
